import { useTranslation } from 'react-i18next';
import Box from '@cloudscape-design/components/box';
import Button from '@cloudscape-design/components/button';
import SpaceBetween from '@cloudscape-design/components/space-between';

/**
 * Tela de fallback dos boundaries do admin (`ErrorBoundary` global, #12
 * §3.4.3, e `RouteErrorBoundary`, #795): texto i18n e botão de recarregar,
 * sem stack. Em arquivo próprio para o Fast Refresh continuar valendo (o
 * `ErrorBoundary` é class component). Cloudscape, sem Tailwind.
 */
export function ErrorFallback(): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <Box margin={{ top: 'xxxl' }} padding="l" textAlign="center">
      <SpaceBetween size="m">
        <Box variant="h1">{t('admin.errorBoundary.title')}</Box>
        <Box variant="p" color="text-body-secondary">
          {t('admin.errorBoundary.description')}
        </Box>
        <Button
          variant="primary"
          onClick={() => {
            window.location.reload();
          }}
        >
          {t('admin.errorBoundary.reload')}
        </Button>
      </SpaceBetween>
    </Box>
  );
}
